import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Loan Payments is built. Reached from
// Payroll > Disbursement > Loan Payments in the sidebar flyout.
export const DisbursementLoanPayments = () => <NotImplemented title="Loan Payments" />;
